<template>
  <div class="page page--home">

  </div>
</template>

<script>
import { store } from '../store'
export default {
	name: 'home',
	store: store,
	components: {},
	async mounted() {
		this.$router.push({ name: 'AddOrder' })
	},
	methods: {}
}
</script>
